import { ClientApiConfig } from '@quadminds/client-apis/base';

export interface AgentsApiConfig extends ClientApiConfig {
    /**
     * Add authentication interceptors for 401 responses
     */
    useUnauthorizedInterceptor?: boolean;
}
